import { getHttpClient } from 'src/http-client';

/* eslint-disable @typescript-eslint/no-explicit-any */
const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

const filterHandler = (map: Map<string, any>) => {
	const resultMap = map;
	const set = (key: string, value: any) => {
		if (value) {
			resultMap.set(key, value);
		}

		return resultMap;
	};

	return {
		set,
		get: resultMap.get,
		getObject: () => Object.fromEntries(resultMap)
	};
};

export async function getAutomationActivitiesService(args: {
  organizationName: string;
  projectId: string;
  automationId: string | null;
  lastItem: string | null;
  pageSize: string | null;
  lastTime?: string;
	status?: string;
}) {

	const mapParams = new Map();
	const filters = filterHandler(mapParams);
  
	filters.set('pageSize', args.pageSize);
	filters.set('lastItem', args.lastItem);
	filters.set('automationId', args.automationId);
	filters.set('lastTime', args.lastTime);
	filters.set('status', args.status);
  
	const httpClient = getHttpClient();
	const response = await httpClient.get(`${apiUrl}/automation-rule-logs/${args.organizationName}/${args.projectId}`, {
		params: filters.getObject(),
		headers: {
			'Content-Type': 'application/json'
		}
	});

	return response;
}